import type { Feature, FeatureCollection, MultiPolygon, Polygon } from 'geojson';

import { booleanValid } from '@turf/turf';

// Returns the indices (in FeatureCollection.features order) of any polygon
// or multi-polygon features that fail @turf/turf's booleanValid check. Non-
// polygon features are treated as invalid and surfaced as well — prescription
// shapefiles must be fully polygonal.
export const findInvalidPolygonIndices = ({
    featureCollection
}: {
    featureCollection: FeatureCollection;
}): number[] => {
    const invalidIndices: number[] = [];

    featureCollection.features.forEach((feature, index) => {
        if (!isPolygonalFeature(feature)) {
            invalidIndices.push(index);

            return;
        }

        try {
            if (!booleanValid(feature)) {
                invalidIndices.push(index);
            }
        } catch {
            // booleanValid throws on malformed rings — treat as invalid.
            invalidIndices.push(index);
        }
    });

    return invalidIndices;
};

const isPolygonalFeature = (feature: Feature): feature is Feature<Polygon | MultiPolygon> => {
    if (!feature.geometry) {
        return false;
    }

    return feature.geometry.type === 'Polygon' || feature.geometry.type === 'MultiPolygon';
};
